export default "__VITE_PUBLIC_ASSET__28be14ef__"